import { useEffect } from "react";
import { ConnectorConnectDialog } from "./ConnectorConnectDialog";
import { ExtensionAccessDialog } from "./ExtensionAccessDialog";
import type { useChatTurns } from "./useChatTurns";

/**
 * What the last reply asked of me before it can go on: allow an extension, then connect a connector.
 * One dialog at a time; the message is retried once, after the last step. A reply stopped by Retry (it seemed
 * stuck) has its message sent again once it has ended.
 */
export function ReplyFollowUps({
  turns,
  retry,
}: Readonly<{ turns: ReturnType<typeof useChatTurns>; retry: (prompt: string) => void }>) {
  const { extensionAccess, connectorConnect, retryPrompt, retried } = turns;
  useEffect(() => {
    if (!retryPrompt) return;
    retried();
    retry(retryPrompt);
  }, [retryPrompt, retried, retry]);
  return (
    <>
      {extensionAccess && (
        <ExtensionAccessDialog
          request={extensionAccess}
          onClose={turns.dismissExtensionAccess}
          onAllowed={() => {
            const prompt = turns.allowedExtensionAccess();
            if (prompt) retry(prompt);
          }}
        />
      )}
      {connectorConnect && (
        <ConnectorConnectDialog
          request={connectorConnect}
          prompt={connectorConnect.prompt}
          onClose={turns.dismissConnectorConnect}
          onConnected={() => {
            turns.dismissConnectorConnect();
            if (connectorConnect.prompt) retry(connectorConnect.prompt);
          }}
        />
      )}
    </>
  );
}
